import facebook_icon from './facebook_icon.svg'
import zalo_icon from './zalo_icon.svg'
import cart_icon from './cart.svg'
import delete_icon from './delete.svg'
import momo_icon from './momo.svg'
import Iphone from './mobile_phone.svg'
import done from './done.svg'

const SvgIcon = {
    FACEBOOK_ICON: facebook_icon,
    ZALO_ICON: zalo_icon,
    CART_ICON: cart_icon,
    DELETE_ICON: delete_icon,
    MOMO_ICON: momo_icon,
    IPHONE: Iphone,
    DONE: done,
}

export default SvgIcon